export const FREE_PLANS = ["FREE"]
export const VENDOR_PLANS = ["VENDOR-MONTHLY"];
export const PLANNER_PLANS = ["PLANNER-MONTHLY", "MASTER-PLANNER-MONTHLY"];
